const { findById } = require('../util');


/**
 * 风险视图数据（左）
 * @type {*[]}
 */
let leftData = [
    { company: 1, value: 89 },
    { company: 2, value: 34 },
    { company: 3, value: 76 },
    { company: 4, value: 87 },
    { company: 5, value: 32 },
    { company: 6, value: 76 },
    { company: 7, value: 87 },
    { company: 8, value: 73 },
];

/**
 * 风险视图数据（右）
 * @type {*[]}
 */
let rightData = [
    { company: 1, value: [4, 6, 7, 8, 9, 9] },
    { company: 2, value: [2, 6, 7, 9, 4, 9] },
    { company: 3, value: [5, 8, 2, 10, 7, 6] },
    { company: 4, value: [6, 4, 2, 5, 10, 7] },
    { company: 5, value: [7, 7, 2, 7, 4, 1] },
    { company: 6, value: [3, 2, 2, 3, 6, 8] },
    { company: 7, value: [6, 5, 2, 5, 5, 6] },
    { company: 8, value: [9, 7, 2, 8, 4, 7] },
];

/**
 * 公司
 * @type {*[]}
 */
let companies = [


    { id: 200001, name: '中信证券', type: '证券公司' },
    { id: 200002, name: '海通证券', type: '证券公司' },
    { id: 200003, name: '广发证券', type: '证券公司' },
    { id: 200004, name: '招商证券', type: '证券公司' },
    { id: 200005, name: '国泰君安', type: '证券公司' },
    { id: 200006, name: '国信证券', type: '证券公司' },
    { id: 200007, name: '华泰证券', type: '证券公司' },
    { id: 200008, name: '中泰证券', type: '证券公司' },
    { id: 200009, name: '申万宏源', type: '证券公司' },

    { id: 400041, name: '国际期货', type: '期货公司' },
    { id: 400042, name: '河南万达', type: '期货公司' },
    { id: 400043, name: '浙江永安', type: '期货公司' },
    { id: 400044, name: '浙江中大', type: '期货公司' },
    { id: 400045, name: '上海通联', type: '期货公司' },
    { id: 400046, name: '金瑞期货', type: '期货公司' },

    { id: 100011, name: '上海证券交易所', type: '证券交易所' },
    { id: 100012, name: '深圳证券交易所', type: '证券交易所' },

    { id: 300031, name: '郑州商品交易所', type: '期货交易所' },
    { id: 300032, name: '上海期货交易所', type: '期货交易所' },
    { id: 300033, name: '大连商品交易所', type: '期货交易所' },
    { id: 300034, name: '中国金融期货交易所', type: '期货交易所' },
    { id: 300035, name: '上海能源交易所', type: '期货交易所' },


];

/**
 * 报送数据项定义集合
 * by ZhaoLei, 20190510
 */
let itemDefSets = [
    { id: 2, name: "2019年普查", creator: 1, createDate: "2019-05-07" },
    { id: 1, name: "预定义集合", creator: 1, createDate: "2019-05-06" }
];

/**
 * 报送数据项定义
 * by ZhaoLei, 20190510
 */
let itemDefs = [
    {
        "set": "2019年普查",
        "id": 1, "var": "nITGSize", "type": "int", "name": "IT组人数",
        "class": "信息安全", "subClass": "组织架构",
        "surveySrc": "表5-信息技术制度情况-IT治理-IT组织架构", "auditSrc": "表A-2-1.1.21",
        "values": [{ "value": "${value}", "description": "IT组人数", "score": "${value}" }],
        "creator": 1, 'createDate': '2019-05-10'
    },
    {
        "set": "2019年普查",
        "id": 2, "var": "nITGSize_LastYear", "type": "int", "name": "上年度IT组人数",
        "class": "信息安全", "subClass": "组织架构",
        "surveySrc": "表5-信息技术制度情况-IT治理-IT组织架构", "auditSrc": "表A-2-1.1.21",
        "values": [{ "value": "${value}", "description": "上年度IT组人数", "score": "${value}" }],
        "creator": 1, 'createDate': '2019-05-10'
    },
    {
        "set": "2019年普查",
        "id": 3, "var": "nServer", "type": "int", "name": "服务器数",
        "class": "信息安全", "subClass": "组织架构",
        "surveySrc": "表5-信息技术制度情况-IT治理-IT组织架构", "auditSrc": "表A-2-1.1.21",
        "values": [{ "value": "${value}", "description": "服务器数", "score": "${value}" }],
        "creator": 1, 'createDate': '2019-05-10'
    },
    {
        "set": "2019年普查",
        "id": 4, "var": "nServer_LastYear", "type": "int", "name": "上年度服务器数",
        "class": "信息安全", "subClass": "组织架构",
        "surveySrc": "表5-信息技术制度情况-IT治理-IT组织架构", "auditSrc": "表A-2-1.1.21",
        "values": [{ "value": "${value}", "description": "上年度服务器数", "score": "${value}" }],
        "creator": 1, 'createDate': '2019-05-10'
    },

    {
        "set": "2019年普查",
        "id": 11, "var": "hasGroup", "type": "enum", "name": "是否建立协调小组并履行职责",
        "class": "信息安全", "subClass": "组织架构",
        "surveySrc": "表5-信息技术制度情况-IT治理-IT组织架构", "auditSrc": "表A-2-1.1.21",
        "values": [
            { "value": 1, "description": "已设立，并承担职能", "score": 10 },
            { "value": 2, "description": "已设立，但未承担职能", "score": 5 },
            { "value": 3, "description": "未设立", "score": 0 }
        ],
        "creator": 1, 'createDate': '2019-05-10'
    },
    {
        "set": "2019年普查",
        "id": 12, "var": "hasRiskManager", "type": "enum",
        "class": "信息安全", "subClass": "组织架构", "name": "是否建立风险管理团队并履行职责",
        "surveySrc": "表5-信息技术制度情况-IT治理-IT组织架构", "auditSrc": "表A-2-1.1.21",
        "values": [
            { "value": 1, "description": "已设立，并承担职能", "score": 10 },
            { "value": 2, "description": "已设立，但未承担职能", "score": 5 },
            { "value": 3, "description": "未设立", "score": 0 }
        ],
        "creator": 1, 'createDate': '2019-05-10'
    },
    {
        "set": "2019年普查",
        "id": 13, "var": "hasMonitor", "type": "enum",
        "class": "信息安全", "subClass": "组织架构", "name": "是否建立内控团队并履行职责",
        "surveySrc": "表5-信息技术制度情况-IT治理-IT组织架构", "auditSrc": "表A-2-1.1.21",
        "values": [
            { "value": 1, "description": "已设立，并承担职能", "score": 10 },
            { "value": 2, "description": "已设立，但未承担职能", "score": 5 },
            { "value": 3, "description": "未设立", "score": 0 }
        ],
        "creator": 1, 'createDate': '2019-05-10'
    },
    {
        "set": "2019年普查",
        "id": 14, "var": "hasOfficer", "type": "enum",
        "class": "信息安全", "subClass": "风险评估点", "name": "是否建立安全管理员并履行职责",
        "surveySrc": "表5-信息技术制度情况-IT治理-IT组织架构", "auditSrc": "表A-2-1.1.21",
        "values": [
            { "value": 1, "description": "已设立，并承担职能", "score": 10 },
            { "value": 2, "description": "已设立，但未承担职能", "score": 5 },
            { "value": 3, "description": "未设立", "score": 0 }
        ],
        "creator": 1, 'createDate': '2019-05-10'
    },
    {
        "set": "2019年普查",
        "id": 15, "var": "hasABRole", "type": "enum",
        "class": "信息安全", "subClass": "风险评估点", "name": "是否建立协调小组并履行职责",
        "surveySrc": "表5-信息技术制度情况-IT治理-IT组织架构", "auditSrc": "表A-2-1.1.21",
        "values": [
            { "value": 1, "description": "已设立，并承担职能", "score": 10 },
            { "value": 2, "description": "已设立，但未承担职能", "score": 5 },
            { "value": 3, "description": "未设立", "score": 0 }
        ],
        "creator": 1, 'createDate': '2019-05-10'
    }
];


/**
 * 数据项
 * @type {*[]}
 */
let items = [
    // company 1
    { id: 1, name: 'IT人数', value: '200', target: 1, company: 1 },
    { id: 2, name: '上年度离职IT人数', value: '11', target: 1, company: 1 },
    { id: 3, name: '组织结构是否完备', value: '10', target: 2, company: 1 },
    { id: 4, name: 'IT关键岗位AB角', value: '5', target: 3, company: 1 },
    { id: 5, name: '不相容岗位由不同人员担任', value: '10', target: 4, company: 1 },
    { id: 6, name: '体系建设情况', value: '5', target: 5, company: 1 },
    { id: 7, name: '制度检查情况', value: '0', target: 6, company: 1 },
    // company 2
    { id: 9, name: 'IT人数', value: '90', target: 1, company: 2 },
    { id: 10, name: '上年度离职IT人数', value: '7', target: 1, company: 2 },
    { id: 11, name: '组织结构是否完备', value: '5', target: 2, company: 2 },
    { id: 12, name: 'IT关键岗位AB角', value: '10', target: 3, company: 2 },
    { id: 13, name: '不相容岗位由不同人员担任', value: '10', target: 4, company: 2 },
    { id: 14, name: '体系建设情况', value: '0', target: 5, company: 2 },
    { id: 15, name: '制度检查情况', value: '5', target: 6, company: 2 },
    // company 3
    { id: 16, name: 'IT人数', value: '1000', target: 1, company: 3 },
    { id: 17, name: '上年度离职IT人数', value: '37', target: 1, company: 3 },
    { id: 18, name: '组织结构是否完备', value: '10', target: 2, company: 3 },
    { id: 19, name: 'IT关键岗位AB角', value: '5', target: 3, company: 3 },
    { id: 20, name: '不相容岗位由不同人员担任', value: '5', target: 4, company: 3 },
    { id: 21, name: '体系建设情况', value: '5', target: 5, company: 3 },
    { id: 22, name: '制度检查情况', value: '5', target: 6, company: 3 },
    // company 4
    { id: 23, name: 'IT人数', value: '76', target: 1, company: 4 },
    { id: 24, name: '上年度离职IT人数', value: '2', target: 1, company: 4 },
    { id: 25, name: '组织结构是否完备', value: '5', target: 2, company: 4 },
    { id: 26, name: 'IT关键岗位AB角', value: '5', target: 3, company: 4 },
    { id: 27, name: '不相容岗位由不同人员担任', value: '10', target: 4, company: 4 },
    { id: 28, name: '体系建设情况', value: '5', target: 5, company: 4 },
    { id: 29, name: '制度检查情况', value: '10', target: 6, company: 4 },
    // company 5
    { id: 30, name: 'IT人数', value: '490', target: 1, company: 5 },
    { id: 31, name: '上年度离职IT人数', value: '50', target: 1, company: 5 },
    { id: 32, name: '组织结构是否完备', value: '5', target: 2, company: 5 },
    { id: 33, name: 'IT关键岗位AB角', value: '5', target: 3, company: 5 },
    { id: 34, name: '不相容岗位由不同人员担任', value: '10', target: 4, company: 5 },
    { id: 35, name: '体系建设情况', value: '5', target: 5, company: 5 },
    { id: 36, name: '制度检查情况', value: '5', target: 6, company: 5 },
    // company 6
    { id: 37, name: 'IT人数', value: '30', target: 1, company: 6 },
    { id: 38, name: '上年度离职IT人数', value: '1', target: 1, company: 6 },
    { id: 39, name: '组织结构是否完备', value: '0', target: 2, company: 6 },
    { id: 40, name: 'IT关键岗位AB角', value: '5', target: 3, company: 6 },
    { id: 41, name: '不相容岗位由不同人员担任', value: '10', target: 4, company: 6 },
    { id: 42, name: '体系建设情况', value: '5', target: 5, company: 6 },
    { id: 43, name: '制度检查情况', value: '0', target: 6, company: 6 },
    // company 7
    { id: 44, name: 'IT人数', value: '89', target: 1, company: 7 },
    { id: 45, name: '上年度离职IT人数', value: '55', target: 1, company: 7 },
    { id: 46, name: '组织结构是否完备', value: '0', target: 2, company: 7 },
    { id: 47, name: 'IT关键岗位AB角', value: '5', target: 3, company: 7 },
    { id: 48, name: '不相容岗位由不同人员担任', value: '0', target: 4, company: 7 },
    { id: 49, name: '体系建设情况', value: '5', target: 5, company: 7 },
    { id: 50, name: '制度检查情况', value: '0', target: 6, company: 7 },
    // company 8
    { id: 51, name: 'IT人数', value: '10000', target: 1, company: 8 },
    { id: 52, name: '上年度离职IT人数', value: '76', target: 1, company: 8 },
    { id: 53, name: '组织结构是否完备', value: '10', target: 2, company: 8 },
    { id: 54, name: 'IT关键岗位AB角', value: '5', target: 3, company: 8 },
    { id: 55, name: '不相容岗位由不同人员担任', value: '10', target: 4, company: 8 },
    { id: 56, name: '体系建设情况', value: '5', target: 5, company: 8 },
    { id: 57, name: '制度检查情况', value: '10', target: 6, company: 8 },
];

/**
 * 指标
 * @type {*[]}
 */
let targets = [
    {
        id: 11,
        type: '组织架构',
        name: 'IT人员流失率',
        code: 'lostRate_ITStuff',
        set: 1,
        formula: '$上年度离职IT人数$ / $IT人数$',
        desc: '每年离职IT人数与总IT人数的比例'
    },
    {
        id: 12,
        type: '组织架构',
        name: '组织结构完备性',
        code: 'conCompleteness',
        set: 1,
        formula: '(-5 * $组织结构是否完备$ + 15)',
        desc: '已设立安全员、并负责落实安全策略及开展安全评审等工作：10分；已设置安全员，但未负责落实工作：5分；未设置安全员：0分。'
    },
    {
        id: 13,
        type: 'IT关键岗位',
        name: 'IT关键岗位AB角',
        code: 'assignABRole',
        set: 1,
        formula: '(-5 * $IT关键岗位AB角$ + 15)',
        desc: '对IT关键岗位全部配置AB角：10分；部分配置AB角：5分；未配置AB角：0分。'
    },
    {
        id: 14,
        type: 'IT关键岗位',
        name: '不相容岗位设置',
        code: 'assignImcompPos',
        set: 1,
        formula: '(-10 * $不相容岗位设置$ + 20)',
        desc: '不相容岗位武兼任情况：10分；存在兼任情况：0分。'
    },
    {
        id: 15,
        type: '制度建设',
        name: '体系建设情况',
        code: 'isSystemComplete',
        set: 1,
        formula: '(-5 * $体系建设情况$ + 15)',
        desc: '制定完善并发布：10分；制度完善但未发布：5分；缺失：0分。'
    },
    {
        id: 16,
        type: '制度建设',
        name: '制度检查情况',
        code: 'checkSystem',
        set: 1,
        formula: '(-5 * $制度检查情况$ + 15)',
        desc: '每年重检并按时报送：10分；每年重检但未按时报送：5分；未组织重检：0分。'
    },

    /*** 数据安全 ***/
    {
        id: 31,
        type: '分类分级',
        name: '建立分类分级标准',
        code: 'dsBuildCriteria',
        set: 3,
        formula: 'KeyValue( $建立分类分级标准情况$, [ [1,10], [2,5], [3,0] ])',
        desc: '每年重检并按时报送：10分；每年重检但未按时报送：5分；未组织重检：0分。'
    },
    {
        id: 32,
        type: '数据传输',
        name: '建立对外发送邮件审核机制',
        code: 'dsDataTransfer',
        set: 3,
        formula: 'KeyValue( $建立对外发送邮件审核机制情况$, [ [1,10], [2,0] ])',
        desc: '建立对外发送邮件审核机制'
    },
    {
        id: 33,
        type: '数据使用',
        name: '批量提取数据审批机制',
        code: 'dsDataUsage',
        set: 3,
        formula: 'KeyValue( $批量提取数据审批机制情况$, [ [1,10], [2,5], [3,0] ])',
        desc: '批量提取数据审批机制'
    },
    {
        id: 34,
        type: '数据修改',
        name: '建立数据修改管理制度',
        code: 'buildCriteria',
        set: 3,
        formula: 'KeyValue( $建立数据修改管理制度情况$, [ [1,10], [2,3], [3,3], [4,0] ])',
        desc: '建立数据修改管理制度'
    },
    {
        id: 35,
        type: '数据存储',
        name: '建立数据存储管理机制',
        code: 'dsDataStorage',
        set: 3,
        formula: 'KeyValue( $建立数据存储管理机制情况$, [ [1,10], [2,3], [3,0] ])',
        desc: '建立数据销毁机制和流程'
    },
    {
        id: 36,
        type: '数据销毁',
        name: '建立数据销毁机制和流程',
        code: 'dsDataDestroy',
        set: 3,
        formula: 'KeyValue( $建立数据销毁机制和流程情况$, [ [1,10], [2,3], [3,0] ])',
        desc: '建立数据销毁机制和流程'
    },


    /*** 开发安全 ***/
    {
        id: 41,
        type: '安全分析',
        name: '安全分析情况',
        code: 'devSecAnalysis',
        set: 4,
        formula: 'KeyValue( $是否进行安全分析$, [ [1,10], [2,3], [3,3], [4,0] ])',
        desc: '信息系统是否在需求分析时就进行了安全需求分析，并明确了信息安全保护基线要求？'
    },
    {
        id: 42,
        type: '安全编码',
        name: '千行代码中的漏洞数评分',
        code: 'devCoding',
        set: 4,
        formula: 'Piecewise( $千行代码中的漏洞数$, [ [0,1,10], [1,2,8], [2,3,5], [3,10000,0] ])',
        desc: '漏洞数量取值范围'
    },
    {
        id: 43,
        type: '上线投产',
        name: '上线投产回退率',
        code: 'devReleaseBack',
        set: 4,
        formula: 'Linear( $上线投产回退率数值$, [-10,10])',
        desc: '回退次数/总上线次数'
    },


    /*** 运维安全 ***/
    {
        id: 51,
        type: '权限管理',
        name: '超级账号受控情况',
        code: 'msSuperAccount',
        set: 5,
        formula: 'KeyValue( $超级账号受控$, [ [1,10], [2,0] ])',
        desc: '超级帐号认证凭证是否实行集中管理，超级帐号认证凭证是否由外部人员管理？'
    },
    {
        id: 52,
        type: '应急管理',
        name: '应急预案覆盖率',
        code: 'msEmgPlanCov',
        set: 5,
        formula: 'Linear( $应急预案覆盖率数值$, [ 10, 0 ])',
        desc: '信息系统预感数/信息系统总数'
    },
    {
        id: 53,
        type: '设备管理',
        name: '安全设备国产率',
        code: 'msMiC',
        set: 5,
        formula: 'Linear( $安全设备国产率数值$, [ 10, 0 ])',
        desc: '国产安全设备数量/安全设备总数量'
    },
    {
        id: 54,
        type: '变更管理',
        name: '紧急变更率',
        code: 'msMiC',
        set: 5,
        formula: 'Linear( $紧急变更率数值$, [ -10, 10 ])',
        desc: '紧急变更次数/全部变更次数'
    },


];

/**
 * 指标集
 * @type {*[]}
 */
let targetCollection = [
    {
        id: 1,
        targetName: '信息安全',
        builder: '管理员',
        createTime: '2019-03-15',
        information: '包括组织架构、IT关键岗位、制度建设等方面的评估指标'
    },
    {
        id: 2,
        targetName: '物理安全',
        builder: '管理员',
        createTime: '2019-03-15',
        information: '包括机房建设、机房容量、安防等方面的评估指标'
    },
    {
        id: 3,
        targetName: '数据安全',
        builder: '管理员',
        createTime: '2019-03-15',
        information: '包括数据分类分级、传输、使用、修改、存储等方面的评估指标'
    },
    {
        id: 4,
        targetName: '开发安全',
        builder: '管理员',
        createTime: '2019-03-15',
        information: '包括安全分析、安全编码、上线投产等方面的评估指标'
    },
    {
        id: 5,
        targetName: '运维安全',
        builder: '管理员',
        createTime: '2019-03-15',
        information: '包括权限管理、应急管理、设备管理、变更管理等方面的评估指标'
    },
    {
        id: 6,
        targetName: '外包安全',
        builder: '管理员',
        createTime: '2019-03-15',
        information: '包括应急管理、人员管理、合同管理等方面的评估指标'
    },
    {
        id: 7,
        targetName: '应用安全',
        builder: '管理员',
        createTime: '2019-03-15',
        information: '包括系统定级、应用评估、安全巡检、日志管理、安全防护等方面的评估指标'
    }
];

let dataItems = [
    {
        id: 11,
        type: '信息安全',
        name: '上年度离职IT人数',
    },
    {
        id: 12,
        type: '信息安全',
        name: 'IT人数',
    },
    {
        id: 13,
        type: '信息安全',
        name: '组织结构是否完备',
    },
    {
        id: 14,
        type: '信息安全',
        name: 'IT关键岗位AB角',
    },
    {
        id: 15,
        type: '信息安全',
        name: '不相容岗位设置',
    },
    {
        id: 16,
        type: '信息安全',
        name: '体系建设情况',
    },
    {
        id: 17,
        type: '信息安全',
        name: '制度检查情况',
    },


    /*** 数据安全 ***/
    {
        id: 31,
        type: '数据安全',
        name: '建立分类分级标准情况',
    },
    {
        id: 32,
        type: '数据安全',
        name: '建立对外发送邮件审核机制情况',
    },
    {
        id: 33,
        type: '数据安全',
        name: '批量提取数据审批机制情况',
    },
    {
        id: 34,
        type: '数据安全',
        name: '建立数据修改管理制度情况',
    },
    {
        id: 35,
        type: '数据安全',
        name: '建立数据存储管理机制情况',
    },
    {
        id: 36,
        type: '数据安全',
        name: '建立数据销毁机制和流程情况',
    },


    /*** 开发安全 ***/

    {
        id: 41,
        type: '开发安全',
        name: '是否进行安全分析',
    },
    {
        id: 42,
        type: '开发安全',
        name: '千行代码中的漏洞数',
    },
    {
        id: 43,
        type: '开发安全',
        name: '上线投产回退率数值',
    },


    /*** 运维安全 ***/
    {
        id: 51,
        type: '运维安全',
        name: '超级账号受控',
    },
    {
        id: 52,
        type: '运维安全',
        name: '应急预案覆盖率数值',
    },
    {
        id: 53,
        type: '运维安全',
        name: '安全设备国产率数值',
    },
    {
        id: 54,
        type: '运维安全',
        name: '紧急变更率数值',
    },

];

let models = [
    {
        id: 1,
        type: '证券公司风险评估模型',
        default: true,
        weight: '风险评估模型',
        function: '0.4*$数据安全$ + 0.4*$开发安全$ + 0.2*$运维安全$',
        aspect: [
            {id:1, name:'信息安全', qz:0,function:'0.2*$IT人员流失率$ + 0.8*$组织结构完备性$' },
            {id:2, name:'物理安全', qz:0,function:'0' },
            {id:3, name:'数据安全', qz:0.4,function:'0.1*$建立分类分级标准$ + 0.2*$建立对外发送邮件审核机制$ + 0.2*$批量提取数据审批机制$ + 0.2*$建立数据修改管理制度$ + 0.2*$建立数据存储管理机制$ + 0.1*$建立数据销毁机制和流程$' },
            {id:4, name:'开发安全', qz:0.4,function:'0.2*$安全分析情况$ + 0.5*$千行代码中的漏洞数评分$ + 0.3*$上线投产回退率$' },
            {id:5, name:'运维安全', qz:0.2,function:'0.2*$超级账号受控情况$ + 0.2*$应急预案覆盖率$ + 0.3*$安全设备国产率$ + 0.3*$紧急变更率$'},
            {id:6, name:'外包安全', qz:0,function:'0' },
            {id:7, name:'应用安全', qz:0,function:'0' },
        ],
    },
    {
        id: 2,
        type: '证券公司风险评估备用模型',
        default: false,
        weight: '备用模型',
        function: '0.1*$信息安全$ + 0.4*$数据安全$ + 0.3*$开发安全$ + 0.2*$运维安全$',
        aspect: [
            {id:1, name:'信息安全', qz:0.1,function:'0.2*$IT人员流失率$ + 0.8*$组织结构完备性$' },
            {id:2, name:'物理安全', qz:0,function:'0' },
            {id:3, name:'数据安全', qz:0.4,function:'0.1*$建立分类分级标准$ + 0.2*$建立对外发送邮件审核机制$ + 0.2*$批量提取数据审批机制$ + 0.2*$建立数据修改管理制度$ + 0.2*$建立数据存储管理机制$ + 0.1*$建立数据销毁机制和流程$' },
            {id:4, name:'开发安全', qz:0.3,function:'0.2*$安全分析情况$ + 0.5*$千行代码中的漏洞数评分$ + 0.3*$上线投产回退率$' },
            {id:5, name:'运维安全', qz:0.2,function:'0.2*$超级账号受控情况$ + 0.2*$应急预案覆盖率$ + 0.3*$安全设备国产率$ + 0.3*$紧急变更率$'},
            {id:6, name:'外包安全', qz:0,function:'0' },
            {id:7, name:'应用安全', qz:0,function:'0' },
        ],
    },
];

let initialData = [
        //数据项
        {
            event: 1,
            org: 1,
            data: [
                {name: "上年度离职IT人数", value: 12},
                {name: "IT人数", value: 80},
                {name: "组织结构是否完备", value: 1},
                {name: "IT关键岗位AB角", value: 1},
                {name: "体系建设情况", value: 1},
                {name: "制度检查情况", value: 1},
                {name: "不相容岗位设置", value: 1},

                {name: "建立分类分级标准情况", value: 1},
                {name: "建立对外发送邮件审核机制情况", value: 1},
                {name: "批量提取数据审批机制情况", value: 1},
                {name: "建立数据修改管理制度情况", value: 1},
                {name: "建立数据存储管理机制情况", value: 1},
                {name: "建立数据销毁机制和流程情况", value: 1},

                {name: "是否进行安全分析", value: 1},
                {name: "千行代码中的漏洞数", value: 0.5},
                {name: "上线投产回退率数值", value: 0.1},

                {name: "超级账号受控", value: 1},
                {name: "应急预案覆盖率数值", value: 0.95},
                {name: "安全设备国产率数值", value: 0.85},
                {name: "紧急变更率数值", value: 0.1},

            ]
        },
        {
            event: 1,
            org: 2,
            data: [
                {name: "上年度离职IT人数", value: 2},
                {name: "IT人数", value: 10},
                {name: "组织结构是否完备", value: 1},
                {name: "IT关键岗位AB角", value: 1},
                {name: "体系建设情况", value: 2},
                {name: "制度检查情况", value: 1},
                {name: "不相容岗位设置", value: 1},

                {name: "建立分类分级标准情况", value: 1},
                {name: "建立对外发送邮件审核机制情况", value: 2},
                {name: "批量提取数据审批机制情况", value: 2},
                {name: "建立数据修改管理制度情况", value: 2},
                {name: "建立数据存储管理机制情况", value: 2},
                {name: "建立数据销毁机制和流程情况", value: 1},

                {name: "是否进行安全分析", value: 2},
                {name: "千行代码中的漏洞数", value: 1.5},
                {name: "上线投产回退率数值", value: 0.2},

                {name: "超级账号受控", value: 1},
                {name: "应急预案覆盖率数值", value: 0.90},
                {name: "安全设备国产率数值", value: 0.80},
                {name: "紧急变更率数值", value: 0.2},
            ]
        },
        {
            event: 1,
            org: 3,
            data: [
                {name: "上年度离职IT人数", value: 15},
                {name: "IT人数", value: 30},
                {name: "组织结构是否完备", value: 2},
                {name: "IT关键岗位AB角", value: 2},
                {name: "体系建设情况", value: 1},
                {name: "制度检查情况", value: 2},
                {name: "不相容岗位设置", value: 1},

                {name: "建立分类分级标准情况", value: 3},
                {name: "建立对外发送邮件审核机制情况", value: 2},
                {name: "批量提取数据审批机制情况", value: 3},
                {name: "建立数据修改管理制度情况", value: 4},
                {name: "建立数据存储管理机制情况", value: 3},
                {name: "建立数据销毁机制和流程情况", value: 3},

                {name: "是否进行安全分析", value: 4},
                {name: "千行代码中的漏洞数", value: 4.5},
                {name: "上线投产回退率数值", value: 0.4},

                {name: "超级账号受控", value: 1},
                {name: "应急预案覆盖率数值", value: 0.20},
                {name: "安全设备国产率数值", value: 0.30},
                {name: "紧急变更率数值", value: 0.5},
            ]
        },
        {
            event: 1,
            org: 4,
            data: [
                {name: "上年度离职IT人数", value: 10},
                {name: "IT人数", value: 30},
                {name: "组织结构是否完备", value: 2},
                {name: "IT关键岗位AB角", value: 2},
                {name: "体系建设情况", value: 1},
                {name: "制度检查情况", value: 2},
                {name: "不相容岗位设置", value: 1},

                {name: "建立分类分级标准情况", value: 2},
                {name: "建立对外发送邮件审核机制情况", value: 1},
                {name: "批量提取数据审批机制情况", value: 3},
                {name: "建立数据修改管理制度情况", value: 1},
                {name: "建立数据存储管理机制情况", value: 2},
                {name: "建立数据销毁机制和流程情况", value: 1},

                {name: "是否进行安全分析", value: 2},
                {name: "千行代码中的漏洞数", value: 0.5},
                {name: "上线投产回退率数值", value: 0.12},

                {name: "超级账号受控", value: 1},
                {name: "应急预案覆盖率数值", value: 0.80},
                {name: "安全设备国产率数值", value: 0.70},
                {name: "紧急变更率数值", value: 0.3},
            ]
        },
        {
            event: 1,
            org: 5,
            data: [
                {name: "上年度离职IT人数", value: 6},
                {name: "IT人数", value: 30},
                {name: "组织结构是否完备", value: 2},
                {name: "IT关键岗位AB角", value: 2},
                {name: "体系建设情况", value: 1},
                {name: "制度检查情况", value: 2},
                {name: "不相容岗位设置", value: 1},

                {name: "建立分类分级标准情况", value: 3},
                {name: "建立对外发送邮件审核机制情况", value: 2},
                {name: "批量提取数据审批机制情况", value: 2},
                {name: "建立数据修改管理制度情况", value: 2},
                {name: "建立数据存储管理机制情况", value: 3},
                {name: "建立数据销毁机制和流程情况", value: 2},

                {name: "是否进行安全分析", value: 3},
                {name: "千行代码中的漏洞数", value: 1.5},
                {name: "上线投产回退率数值", value: 0.5},

                {name: "超级账号受控", value: 1},
                {name: "应急预案覆盖率数值", value: 0.90},
                {name: "安全设备国产率数值", value: 0.60},
                {name: "紧急变更率数值", value: 0.4},
            ]
        },
        {
            event: 1,
            org: 6,
            data: [
                {name: "上年度离职IT人数", value: 6},
                {name: "IT人数", value: 30},
                {name: "组织结构是否完备", value: 2},
                {name: "IT关键岗位AB角", value: 2},
                {name: "体系建设情况", value: 1},
                {name: "制度检查情况", value: 2},
                {name: "不相容岗位设置", value: 3},

                {name: "建立分类分级标准情况", value: 1},
                {name: "建立对外发送邮件审核机制情况", value: 2},
                {name: "批量提取数据审批机制情况", value: 3},
                {name: "建立数据修改管理制度情况", value: 1},
                {name: "建立数据存储管理机制情况", value: 2},
                {name: "建立数据销毁机制和流程情况", value: 3},

                {name: "是否进行安全分析", value: 2},
                {name: "千行代码中的漏洞数", value: 3.5},
                {name: "上线投产回退率数值", value: 0.2},

                {name: "超级账号受控", value: 1},
                {name: "应急预案覆盖率数值", value: 0.10},
                {name: "安全设备国产率数值", value: 0.50},
                {name: "紧急变更率数值", value: 0.1},
            ]
        },
        {
            event: 1,
            org: 7,
            data: [
                {name: "上年度离职IT人数", value: 13},
                {name: "IT人数", value: 70},
                {name: "组织结构是否完备", value: 2},
                {name: "IT关键岗位AB角", value: 2},
                {name: "体系建设情况", value: 3},
                {name: "制度检查情况", value: 2},
                {name: "不相容岗位设置", value: 3},

                {name: "建立分类分级标准情况", value: 1},
                {name: "建立对外发送邮件审核机制情况", value: 2},
                {name: "批量提取数据审批机制情况", value: 1},
                {name: "建立数据修改管理制度情况", value: 1},
                {name: "建立数据存储管理机制情况", value: 1},
                {name: "建立数据销毁机制和流程情况", value: 3},

                {name: "是否进行安全分析", value: 2},
                {name: "千行代码中的漏洞数", value: 0.5},
                {name: "上线投产回退率数值", value: 0.1},

                {name: "超级账号受控", value: 1},
                {name: "应急预案覆盖率数值", value: 0.90},
                {name: "安全设备国产率数值", value: 0.90},
                {name: "紧急变更率数值", value: 0.1},
            ]
        },

    ];

function initData() {
    console.log('初始化数据');
    for (let i = 0; i < leftData.length; i++) {
        leftData[i].company = findById(companies, leftData[i].company);
    }
    for (let i = 0; i < rightData.length; i++) {
        rightData[i].company = findById(companies, rightData[i].company);
    }
    for (let i = 0; i < items.length; i++) {
        items[i].target = findById(targets, items[i].target);
    }
    for (let i = 0; i < items.length; i++) {
        items[i].company = findById(companies, items[i].company);
    }
}

initData();

export { leftData, rightData, companies, itemDefs, itemDefSets, items, targets, targetCollection, models, dataItems, initialData }
